import client from "./client";

export const getCompanyProfile = (recruiterId) =>
  client.get(`/companies/${recruiterId}`);
